import { IsDefined, IsNumber, IsOptional, IsString } from 'class-validator';
import { IActivityFeedUserData } from '../../interface/activity-feed';

export class ActivityFeedUserDataDto implements IActivityFeedUserData {
  @IsDefined()
  @IsString()
  name: string;

  @IsDefined()
  @IsString()
  username: string;

  @IsOptional()
  @IsString()
  image?: string;

  @IsDefined()
  @IsString()
  merchantGroupId: string;

  @IsOptional()
  @IsNumber()
  jobTitleId?: number;

  @IsOptional()
  @IsNumber()
  merchantId?: number;

  @IsOptional()
  @IsNumber()
  costCentreId?: number;

  @IsOptional()
  @IsNumber()
  departmentId?: number;

  [x: string]: unknown;
}
